export default __webpack_public_path__ + "static/media/boladetransferencia.51bf7d1f.png";